import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  CircularProgress,
  Paper,
  TableContainer,
} from "@mui/material";
import instance from "../../ApiInstance/Inetrceptor";
import CloseIcon from "@mui/icons-material/Close";
import DetailedDialog from "./KeyDetails";
const StatsByTbNumber = () => {
  const [keysArray, setKeysArray] = useState([]);
  const [originalMessageTableData, setOriginalMessageTableData] = useState({});
  const [currentKeyIndex, setCurrentKeyIndex] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [textboxValue, setTextboxValue] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedKey, setSelectedKey] = useState(null); // State to manage selected key
  const [direction, setDirection] = useState(null);
  const [jobref, setJobref] = useState(null);
  const [detailedDialogOpen, setDetailedDialogOpen] = useState(false); // State to manage detailed dialog open state

  const getMessageLogRecords = async () => {
    setLoading(true);
    const body = {
      id: textboxValue,
      selected_direction: "T",
    };

    try {
      const res = await instance.post(
        "api/v1/Message/GetMessageTimeline",
        body
      );
      if (res?.data?.Success) {
        const value = res?.data?.Value;
        setOriginalMessageTableData(value);
        setKeysArray(Object.keys(value));
      } else {
        setOriginalMessageTableData({});
        setKeysArray([]);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handlePrevClick = () => {
    if (currentKeyIndex > 0) {
      setCurrentKeyIndex((prevIndex) => prevIndex - 1);
    }
  };

  const handleNextClick = () => {
    if (currentKeyIndex < keysArray.length - 1) {
      setCurrentKeyIndex((prevIndex) => prevIndex + 1);
    }
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleSearchClick = () => {
    const tbNumberPattern = /^TB/i; // Regular expression to check if the string starts with 'TB' (case insensitive)

    if (textboxValue.trim() === "") {
      setError("Please Enter Transport Booking Number.");
    } else if (!tbNumberPattern.test(textboxValue.trim())) {
      setError("Transport Booking Number is incorrect.");
    } else {
      setOpenDialog(true);
      getMessageLogRecords();
    }
  };

  const handleInputChange = (event) => {
    setTextboxValue(event.target.value);
    setError("");
  };
  const handleDetailedDialogClose = () => {
    setDetailedDialogOpen(false); // Close the detailed dialog
  };
  const handleKeyClick = ({ key, Direction, Job_Reference }) => {
    setSelectedKey(key); // Set the selected key
    setDirection(Direction);
    setJobref(Job_Reference);
    setDetailedDialogOpen(true); // Open the detailed dialog
  };
  const renderFroTimelineTable = () => {
    const currentKey = keysArray[currentKeyIndex];
    const froTimelineData =
      originalMessageTableData[currentKey]?.fro_timeline || [];

    if (!froTimelineData || froTimelineData.length === 0) {
      return (
        <Typography variant="body1">No data found for Fro timeline.</Typography>
      );
    }

    return (
      <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Message Identifier</TableCell>
              <TableCell>Response Message Code</TableCell>
              <TableCell>Response Generated At</TableCell>
              <TableCell>Response Posted on SFTP At</TableCell>
              <TableCell>Message FRO ID</TableCell>
              <TableCell>Job Reference</TableCell>
              <TableCell>Message Creation Timestamp</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {froTimelineData.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <span
                    style={{
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                    onClick={() =>
                      handleKeyClick({
                        key: item.message_identifier,
                        Direction: "F",
                        Job_Reference: item?.job_reference,
                      })
                    }
                  >
                    {item?.message_identifier}
                  </span>
                </TableCell>
                <TableCell>{item?.response_message_code}</TableCell>
                <TableCell>{item?.response_generated_at}</TableCell>
                <TableCell>{item?.response_posted_on_SFTP_at}</TableCell>
                <TableCell>{item?.message_fro_id}</TableCell>
                <TableCell>{item?.job_reference}</TableCell>
                <TableCell>{item?.message_creation_timestamp}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const renderToTimeline = () => {
    const currentKey = keysArray[currentKeyIndex];
    const timeline = originalMessageTableData[currentKey]?.to_timeline || {};
    const status1Fields = timeline.status_1 || {};

    if (Object.keys(timeline).length === 0) {
      return (
        <div>
          <Typography variant="h6" gutterBottom>
            To Timeline
          </Typography>
          <Typography variant="body1">
            No data found for To timeline.
          </Typography>
        </div>
      );
    }

    return (
      <div>
        <strong>To Timeline :</strong>
        <br />
        {Object.keys(timeline).length > 0 && (
          <>
            Trucker ID: {timeline.trucker_id}
            <br />
            Sent to Batch: {timeline.sent_to_batch ? "Yes" : "No"}
            <br />
            Batch Number: {timeline.batch_number}
            <br />
            Response Status Code: {timeline.current_response_msg_status_code}
            <br />
            Response Status Time: {timeline.current_response_msg_status_time}
            <br />
            Creation Timestamp: {timeline.creation_timestamp}
            <br />
            Job Reference: {timeline.job_reference}
            <br />
            Scheduled Process Time: {timeline.scheduled_process_time}
            <br />
            Message Creation Timestamp: {timeline.message_creation_timestamp}
            <br />
            Message Filepath: {timeline.message_filepath}
            <br />
            <strong>Status_1 :</strong>
            {/* <div style={{ marginLeft: 20 }}>
                            {Object.entries(status1Fields).map(([fieldName, fieldValue], idx) => (
                                <div key={idx}>
                                    <strong>{fieldName}:</strong> {fieldValue}
                                </div>
                            ))}
                            {Object.keys(status1Fields).length === 0 && (
                                <div>No Status_1 fields found.</div>
                            )}
                        </div> */}
            <div style={{ marginLeft: 20 }}>
              {Object.entries(status1Fields).map(
                ([fieldName, fieldValue], idx) => (
                  <div key={idx}>
                    <strong>{fieldName}:</strong>{" "}
                    {fieldName === "Status1 Original Message Identifier" &&
                    fieldValue ? (
                      <a
                        href="#"
                        onClick={() =>
                          handleKeyClick({
                            key: fieldValue,
                            Direction: "T",
                            Job_Reference: `${status1Fields["Custom Reference#"]}_${timeline.job_reference}`,
                          })
                        }
                      >
                        {fieldValue}
                      </a>
                    ) : (
                      fieldValue
                    )}
                  </div>
                )
              )}
              {Object.keys(status1Fields).length === 0 && (
                <div>No Status_1 fields found.</div>
              )}
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "10%",
      }}
    >
      <Typography variant="h6" gutterBottom>
        Enter Transport Booking Number
      </Typography>
      <TextField
        label="Enter TB Number"
        variant="outlined"
        value={textboxValue}
        onChange={handleInputChange}
        error={!!error}
        helperText={error}
        style={{ marginBottom: "10px" }}
      />
      <Button variant="contained" color="secondary" onClick={handleSearchClick}>
        Get Details
      </Button>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth={true}
        sx={{ "& .MuiDialog-paper": { width: "70%", maxWidth: "none" } }}
      >
        <DialogTitle>
          {/* Search Result */}
          <IconButton
            aria-label="close"
            style={{ position: "absolute", right: 10, top: 10 }}
            onClick={handleCloseDialog}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="h6">Transport Booking Details</Typography>
          {loading ? (
            <CircularProgress />
          ) : (
            <>
              {keysArray.length > 0 && (
                <>
                  <strong>Key : </strong>
                  <span
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={() =>
                      handleKeyClick({
                        key: keysArray[currentKeyIndex],
                        Direction: "T",
                        Job_Reference: keysArray?.job_reference,
                      })
                    } // Add click handler to open detailed dialog
                  >
                    {keysArray[currentKeyIndex]}
                  </span>
                </>
                // <Typography variant="body1">
                //     Key: {keysArray[currentKeyIndex]}
                // </Typography>
              )}
              {renderToTimeline()}
              <Typography variant="h6">Fro Timeline</Typography>
              {renderFroTimelineTable()}
              <br />
              {keysArray.length > 0 && (
                <div style={{ float: "right" }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handlePrevClick}
                    disabled={currentKeyIndex === 0}
                  >
                    Prev
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleNextClick}
                    disabled={currentKeyIndex === keysArray.length - 1}
                    style={{ marginLeft: "10px" }}
                  >
                    Next
                  </Button>
                </div>
              )}
            </>
          )}
        </DialogContent>
      </Dialog>
      {/* Detailed Dialog */}
      {selectedKey && (
        <DetailedDialog
          open={detailedDialogOpen}
          handleClose={handleDetailedDialogClose}
          keyData={selectedKey}
          Direction={direction}
          Job_ref={jobref}
        />
      )}
    </div>
  );
};

export default StatsByTbNumber;
//     const [originalMessageTableData, setOriginalMessageTableData] = useState({});
//     const [currentKeyIndex, setCurrentKeyIndex] = useState(0);
//     const [openDialog, setOpenDialog] = useState(false);
//     const [textboxValue, setTextboxValue] = useState("");
//     const [error, setError] = useState("");
//     const [loading, setLoading] = useState(true);

//         const getMessageLogRecords = async () => {
//             setLoading(true);
//             const body = {
//                 id: textboxValue,
//                 selected_direction: "T",
//             };

//             try {
//                 const res = await instance.post("api/v1/Message/GetMessageTimeline", body);
//                 if (res?.data?.Success) {
//                     const value = res?.data?.Value;
//                     setOriginalMessageTableData(value);
//                     setKeysArray(Object.keys(value));
//                 } else {
//                     setOriginalMessageTableData({});
//                     setKeysArray([]);
//                 }
//             } catch (err) {
//                 console.error("Error fetching data:", err);
//             } finally {
//                 setLoading(false);
//             }
//         };

//     // const handleNextClick = () => {
//     //   if (currentKeyIndex < keysArray.length - 1) {
//     //     setCurrentKeyIndex(currentKeyIndex + 1);
//     //   }
//     // };

//     // const handlePrevClick = () => {
//     //   if (currentKeyIndex > 0) {
//     //     setCurrentKeyIndex(currentKeyIndex - 1);
//     //   }
//     // };
//     const handlePrevClick = () => {
//         if (currentKeyIndex > 0) {
//             setCurrentKeyIndex((prevIndex) => prevIndex - 1);
//         }
//     };

//     const handleNextClick = () => {
//         if (currentKeyIndex < keysArray.length - 1) {
//             setCurrentKeyIndex((prevIndex) => prevIndex + 1);
//         }
//     };
//     const handleOpenDialog = () => {
//       setOpenDialog(true);
//     };

//     const handleCloseDialog = () => {
//       setOpenDialog(false);
//     };

//     const handleSearchClick = () => {
//         if (textboxValue.trim() === "") {
//             setError("Please enter a value in the textbox.");
//         } else {
//             setOpenDialog(true);
//             getMessageLogRecords();
//         }
//     };

//     const handleInputChange = (event) => {
//       setTextboxValue(event.target.value);
//       setError("");
//     };

//     const renderFroTimelineTable = () => {
//       const currentKey = keysArray[currentKeyIndex];
//       const froTimelineData =
//         originalMessageTableData[currentKey]?.fro_timeline || [];

//       if (!froTimelineData || froTimelineData.length === 0) {
//         return (
//           <Typography variant="body1">
//             No data found for Fro timeline.
//           </Typography>
//         );
//       }

//       return (
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Response Message Code</TableCell>
//               <TableCell>Response Generated At</TableCell>
//               <TableCell>Response Posted On SFTP At</TableCell>
//               {/* Add more headers as needed */}
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {froTimelineData.map((item, index) => (
//               <TableRow key={index}>
//                 <TableCell>{item.response_message_code}</TableCell>
//                 <TableCell>{item.response_generated_at}</TableCell>
//                 <TableCell>{item.response_posted_on_SFTP_at}</TableCell>
//                 {/* Add more cells as needed */}
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       );
//     };

//     const renderToTimeline = () => {
//       const currentKey = keysArray[currentKeyIndex];
//       const timeline = originalMessageTableData[currentKey]?.to_timeline || {};
//       const status1Fields = timeline.status_1 || {};

//       if (Object.keys(timeline).length === 0) {
//         return (
//             <div>
//             <Typography variant="h6" gutterBottom>
//             To Timeline
//           </Typography>
//           <Typography variant="body1">
//             No data found for To timeline.
//           </Typography></div>
//         );
//       }

//       return (
//         <div>
//           <strong>To Timeline :</strong>
//           <br />
//           {Object.keys(timeline).length > 0 && (
//             <>
//               Trucker ID: {timeline.trucker_id}
//               <br />
//               Sent to Batch: {timeline.sent_to_batch ? "Yes" : "No"}
//               <br />
//               Batch Number: {timeline.batch_number}
//               <br />
//               Response Status Code: {timeline.current_response_msg_status_code}
//               <br />
//               Response Status Time: {timeline.current_response_msg_status_time}
//               <br />
//               Creation Timestamp: {timeline.creation_timestamp}
//               <br />
//               Job Reference: {timeline.job_reference}
//               <br />
//               Scheduled Process Time: {timeline.scheduled_process_time}
//               <br />
//               Message Creation Timestamp: {timeline.message_creation_timestamp}
//               <br />
//               Message Filepath: {timeline.message_filepath}
//               <br />
//               <strong>Status_1 :</strong>
//               <div style={{ marginLeft: 20 }}>
//                 {Object.entries(status1Fields).map(([fieldName, fieldValue], idx) => (
//                   <div key={idx}>
//                     <strong>{fieldName}:</strong> {fieldValue}
//                   </div>
//                 ))}
//                 {Object.keys(status1Fields).length === 0 && (
//                   <div>No Status_1 fields found.</div>
//                 )}
//               </div>
//             </>
//           )}
//         </div>
//       );
//     };

//     return (
//       <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "10%" }}>
//         <Typography variant="h6" gutterBottom>
//           Enter Transport Booking Number
//         </Typography>
//         <TextField
//           label="Enter TB Number"
//           variant="outlined"
//           value={textboxValue}
//           onChange={handleInputChange}
//           error={!!error}
//           helperText={error}
//           style={{ marginBottom: "10px" }}
//         />
//         <Button variant="contained" color="secondary" onClick={handleSearchClick}>
//           Get Details
//         </Button>

//         <Dialog open={openDialog} onClose={handleCloseDialog}>
//           <DialogTitle>
//             {/* Search Result */}
//             <IconButton
//               aria-label="close"
//               style={{ position: "absolute", right: 10, top: 10 }}
//               onClick={handleCloseDialog}
//             >
//               <CloseIcon />
//             </IconButton>
//           </DialogTitle>
//           <DialogContent>
//           <Typography variant="h6">
//                 Transport Booking Details
//               </Typography>
//             {keysArray.length > 0 && (
//               <Typography variant="body1">
//                 Key: {keysArray[currentKeyIndex]}
//               </Typography>
//             )}
//             {renderToTimeline()}
//             <Typography variant="h6" >
//               Fro Timeline
//             </Typography>
//             {renderFroTimelineTable()}
//             {keysArray.length > 0 && (
//                 <>
//             <Button variant="contained" color="Secondary" onClick={handlePrevClick} disabled={currentKeyIndex === 0}>
//               Previous
//             </Button>
//             <Button
//               variant="contained"
//               color="Secondary"
//               onClick={handleNextClick}
//               disabled={currentKeyIndex === keysArray.length - 1}
//               style={{ marginLeft: "10px" }}
//             >
//               Next
//             </Button>
//             </>
//         )}
//           </DialogContent>
//         </Dialog>
//       </div>
//     );
//   };

//   export default StatsByTbNumber;
